import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import confirmTypes from 'helpers/enums/confirmTypes'
import generalActions from 'redux/actions/generalActions'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.GENERAL_CONFIRM

const GeneralConfirm = props => (<Confirm
	btTwo={localize('global_ok')}
	alertTitle={''}
	alertMessage={props.message}
	actionButtonType={0}
	actionTwo={
		() => {
			props.actions.closeConfirm(CONFIRM_TYPE)
		}
	}
	closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)} />)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GeneralConfirm)
